import { useContext } from "react"
import { useTrans } from "@/i18n"
import { AuthLayoutContext } from "@/layouts/AuthLayout"

// Router
import { Routes } from "@/constants/routes"

// UI
import { cn } from "@/lib/utils"
import { Link } from "@/components/Anchor"
import { NavItem } from "./NavItem"

import { SunIcon } from "@/lib/icons"

// Context
import { useCurrentUserRoles } from "@/context/user"
import { UserRoles } from "@/constants/constants"

// Graphql
import { usePaymentTasksCountQuery } from "@/api/graphql"

/**
 * FinanceSubMenu
 */
export function FinanceSubMenu() {
	// Translate
	const t = useTrans()

	// Context
	const { setMobileMenuOpen } = useContext(AuthLayoutContext)
	const { hasRole, hasOneOfRoles } = useCurrentUserRoles()

	// Build state array based on user roles
	const states: string[] = []
	if (hasRole(UserRoles.energyProvider || hasRole(UserRoles.admin))) {
		states.push("pending_supplier")
	}
	if (hasRole(UserRoles.projectOwner || hasRole(UserRoles.admin))) {
		states.push("pending_owner", "pending_owner_payment")
	}

	// Graphql
	const { data: paymentsTasksCount } = usePaymentTasksCountQuery({
		state: states,
	})

	function closeMenu() {
		setMobileMenuOpen(false)
	}

	if (
		hasOneOfRoles(
			UserRoles.energyProvider,
			UserRoles.admin,
			UserRoles.installer,
			UserRoles.projectOwner,
		)
	) {
		return (
			<NavItem
				name={t("common:navigation.finance.title")}
				icon={SunIcon}
				data-testid="common:nav.investments"
			>
				<nav className="space-y-1 pr-3">
					<Link
						className={({ isActive }) =>
							cn(
								isActive && "active-navigation-item",
								"block truncate text-sm hover:text-gray-500",
							)
						}
						href={Routes.FinanceProjects}
						onClick={closeMenu}
					>
						{t("common:navigation.finance.dashboard.link")}
					</Link>
					<Link
						className={({ isActive }) =>
							cn(
								isActive && "active-navigation-item",
								"flex flex-row items-center truncate text-sm hover:text-gray-500",
							)
						}
						href={Routes.FinanceInterestPayments}
						onClick={closeMenu}
						badgeNumber={
							paymentsTasksCount?.interest_payments?.totalCount
						}
					>
						{t("common:navigation.finance.interest_payments.link")}
					</Link>
				</nav>
			</NavItem>
		)
	}

	// Default null
	return null
}
